package org.example.zone360.pages.widgets.developmentOrientation


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowDown
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowUp
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getWidgetDetail
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.getAvatarColor
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.WidgetDetailPayload
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun DevelopmentOrientationDetailsModal(
    widgetNo: Int,
    widgetColor: Color,
    score: Int,
    status: String,
    statusColor: Color,
    data: WidgetDetailResponse?,  // ✅ Nullable
    widgetKey: String,  // ✅ New parameter
    onClose: () -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()

    var selectedSortColumn by remember { mutableStateOf<String?>(null) }
    var isAscending by remember { mutableStateOf(true) }

    var localData by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    var isLoading by remember { mutableStateOf(true) }

    var animatedScore by remember { mutableStateOf(0) }

    LaunchedEffect(score) {

        val start = animatedScore

        repeat(60) { frame ->

            val progress = (frame + 1).toFloat() / 60f

            animatedScore =
                (start + ((score - start) * progress)).toInt()

            delay(20)
        }

        animatedScore = score
    }

    // ✅ Fetch data
    LaunchedEffect(Unit) {
        isLoading = true
        try {
            localData = getWidgetDetail(
                WidgetDetailPayload(
                    organization = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    widgetKey = widgetKey
                )
            )
        } catch (e: Exception) {
            debugPrintln("Failed to fetch widget detail: ${e.message}")
        } finally {
            isLoading = false
        }
    }

    // ✅ Effective data
    val effectiveData = data ?: localData
    val coachList = effectiveData?.coaches ?: emptyList()
    val clubAverage = effectiveData?.clubAverage ?: 0

    // ✅ Sorted coaches
    val sortedCoaches = when (selectedSortColumn) {
        "COACH" -> if (isAscending)
            coachList.sortedBy { it.coachName.lowercase() }
        else
            coachList.sortedByDescending { it.coachName.lowercase() }
        "SCORE" -> if (isAscending)
            coachList.sortedBy { it.score }
        else
            coachList.sortedByDescending { it.score }
        else -> coachList
    }


    // ── Full-screen backdrop ───────────────────────────────────────────────
    Box(
        modifier = Modifier
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("right", "0")
                property("bottom", "0")
                property("z-index", "99999")
                property("background-color", "rgba(0,0,0,0.7)")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
            .onClick { onClose() }
    ) {
        // ── Modal panel ────────────────────────────────────────────────────
        Box(
            modifier = Modifier
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
                .padding(24.px, if (breakpoint < Breakpoint.MD) 15.px else 25.px)
                .styleModifier {
                    property("width", "90%")
                    property("max-width", "450px")
                    property("max-height", "90vh")
                    property("overflow-y", "auto")
                    property("box-shadow", "0 20px 50px rgba(0,0,0,0.25)")
                }
                .onClick { it.stopPropagation() }
        ) {
            Column(modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center) {

                // ── Header: badge + title + close ──────────────────────────
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)
                ) {
                    Box(
                        modifier = Modifier
                            .width(28.px)
                            .height(28.px)
                            .backgroundColor(Palette.CoachTalkPrimaryBlue.rgbLight)
                            .borderRadius(6.px)
                            .margin(right = 10.px),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = widgetNo.toString(),
                            fontSize = 14.px,
                            fontWeight = 700,
                            color = sitePalette.bodyBackgroundSecondary.rgb
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = "Development Orientation",
                        fontSize = 18.px,
                        fontWeight = 700
                    )
                    Box(modifier = Modifier.styleModifier { property("flex", "1") })
                    Box(
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .onClick { onClose() }
                    ) {
                        SpanText(
                            text = "✕",
                            modifier = Modifier.fontSize(18.px).fontWeight(700)
                        )
                    }
                }
                if (isLoading) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(180.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            ProgressIndicator(size = 30.px)
                        }
                    }
                } else {

                    // ── Win Now / Long-Term labels ─────────────────────────────
                    Column(
                        modifier = Modifier.fillMaxWidth(80.percent),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center
                    )
                    {
                        Row(
                            modifier = Modifier.fillMaxWidth().margin(bottom = 10.px),
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            SpanText(
                                "Win Now",
                                Modifier
                                    .fontSize(13.px)
                                    .color(Color.rgb(107, 114, 128))
                            )
                            SpanText(
                                "Long-Term Development",
                                Modifier
                                    .fontSize(13.px)
                                    .color(Color.rgb(107, 114, 128))
                            )
                        }

                        // ── Gradient bar + thumb ───────────────────────────────────
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(12.px)
                                .borderRadius(999.px)
                                .position(Position.Relative)
                                .margin(bottom = 20.px)
                        ) {
                            Div(
                                attrs = Modifier
                                    .fillMaxWidth()
                                    .height(12.px)
                                    .borderRadius(6.px)
                                    .toAttrs {
                                        style {
                                            property(
                                                "background",
                                                "linear-gradient(90deg,#FF3B30 0%,#FF9500 35%,#FFD60A 65%,#22C55E 100%)"
                                            )
                                        }
                                    }
                            )
                            // Thumb indicator — positioned at club average
                            Box(
                                modifier = Modifier
                                    .margin(top = (-6).px)
                                    .width(24.px)
                                    .height(24.px)
                                    .backgroundColor(Colors.White)
                                    .borderRadius(50.percent)
                                    .position(Position.Absolute)
                                    .left(animatedScore.percent)
                                    .transform { translateX((-50).percent) }
                                    .border(2.px, LineStyle.Solid, Color.rgb(209, 213, 219))
                                    .boxShadow(
                                        offsetX = 0.px,
                                        offsetY = 2.px,
                                        blurRadius = 8.px,
                                        color = Color.rgba(0, 0, 0, 0.15f)
                                    )
                            )
                        }
                    }

                    // ── Score ──────────────────────────────────────────────────
                    Row(
                        modifier = Modifier.fillMaxWidth().margin(bottom = 6.px),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.Bottom
                    ) {
                        SpanText(
                            animatedScore.toString(),
                            Modifier
                                .fontSize(36.px)
                                .fontWeight(700)
                                .color(Color.rgb(15, 23, 42))
                        )
                        SpanText(
                            "/100",
                            Modifier
                                .margin(bottom = 8.px)
                                .fontSize(14.px)
                                .fontWeight(600)
                                .color(Color.rgb(15, 23, 42))
                        )
                    }

                    // ── Status ─────────────────────────────────────────────────
                    Row(
                        modifier = Modifier.fillMaxWidth().margin(bottom = 4.px),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        SpanText(
                            "Status: ",
                            Modifier.fontSize(14.px).fontWeight(600).color(Color.rgb(75, 85, 99))
                        )
                        SpanText(
                            status,
                            Modifier.fontSize(14.px).fontWeight(700).color(statusColor)
                        )
                    }

                    // ── Club Avg ───────────────────────────────────────────────
                    Row(
                        modifier = Modifier.fillMaxWidth().margin(bottom = 20.px),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        SpanText(
                            "Club Avg: $clubAverage",
                            Modifier
                                .fontSize(13.px)
                                .fontWeight(500)
                                .color(Color.rgb(75, 85, 99))
                        )
                    }
                }

                // ── Divider ────────────────────────────────────────────────
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(1.px)
                        .backgroundColor(Color.rgb(229, 234, 243))
                        .margin(bottom = 16.px)
                )

                // ── Sortable Table ─────────────────────────────────────────
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .borderRadius(12.px)
                        .styleModifier {
                            property("border", "1px solid #E5EAF3")
                            property("overflow", "hidden")
                        }
                ) {
                    // Table header
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .gap(10.px)
                            .backgroundColor(Color.rgb(248, 250, 252))
                            .padding(leftRight = 20.px, topBottom = 10.px)
                            .borderBottom(1.px, LineStyle.Solid, Color.rgb(229, 234, 243)),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        listOf("COACH", "SCORE").forEachIndexed { index, label ->
                            Row(
                                modifier = Modifier
                                    .width(
                                        when {
                                            index == 0 && window.screen.width < 768 -> 180.px
                                            index == 0 -> 280.px
                                            else -> 80.px
                                        }
                                    )
                                    .cursor(Cursor.Pointer)
                                    .onClick {
                                        if (selectedSortColumn == label) isAscending = !isAscending
                                        else {
                                            selectedSortColumn = label; isAscending = true
                                        }
                                    },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = label,
                                    fontSize = 11.px,
                                    fontWeight = 700,
                                    color = Color.rgb(107, 114, 128)
                                )
                                if (selectedSortColumn == label) {
                                    Box(modifier = Modifier.margin(left = 5.px)) {
                                        if (isAscending) {
                                            FaArrowUp(
                                                modifier = Modifier
                                                    .fontSize(10.px)
                                                    .color(Palette.CoachHeaderGradientOne.rgbLight)
                                            )
                                        } else {
                                            FaArrowDown(
                                                modifier = Modifier
                                                    .fontSize(9.px)
                                                    .color(Palette.CoachHeaderGradientOne.rgbLight)
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // Table body
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(260.px)
                            .overflow(Overflow.Auto)
                    ) {
                        sortedCoaches.forEachIndexed { rowIndex, coach ->

                            val avatarColor = getAvatarColor(coach.coachName)

                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .gap(10.px)
                                    .backgroundColor(
                                        if (rowIndex % 2 == 0) Colors.White
                                        else Color.rgb(250, 251, 252)
                                    )
                                    .padding(
                                        leftRight = if (breakpoint < Breakpoint.MD) 10.px else 20.px,
                                        topBottom = 10.px
                                    )
                                    .borderBottom(1.px, LineStyle.Solid, Color.rgb(241, 245, 249)),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                // Coach column
                                Row(
                                    modifier = Modifier.width(
                                        if (window.screen.width < 768) 180.px else 280.px
                                    ),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    val initials = coach.coachName
                                        .split(" ")
                                        .take(1)
                                        .joinToString("") { it.firstOrNull()?.toString() ?: "" }
                                        .uppercase()

                                    Box(
                                        modifier = Modifier
                                            .width(if (breakpoint < Breakpoint.MD) 25.px else 32.px)
                                            .height(if (breakpoint < Breakpoint.MD) 25.px else 32.px)
                                            .backgroundColor(avatarColor.bg)
                                            .borderRadius(50.percent)
                                            .margin(right = 10.px),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        SpanText(
                                            text = initials,
                                            modifier = Modifier
                                                .fontSize(11.px)
                                                .fontWeight(700)
                                                .color(avatarColor.text)
                                        )
                                    }

                                    SpanText(
                                        text = coach.coachName,
                                        modifier = Modifier
                                            .fontSize(13.px)
                                            .fontWeight(500)
                                            .overflow(Overflow.Hidden)
                                            .whiteSpace(WhiteSpace.NoWrap)
                                            .then(
                                                if (breakpoint < Breakpoint.MD) Modifier.width(140.px)
                                                else Modifier
                                            )
                                            .styleModifier {
                                                property("text-overflow", "ellipsis")
                                            }
                                    )
                                }

                                // Score column
                                FieldTitleTextNormalSimple(
                                    text = "${coach.score}",
                                    width = 80.px,
                                    fontSize = 11.px,
                                    fontWeight = 500
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}